import { FileText } from 'lucide-react';

import { TextWithSubfactReferences } from './TextWithSubfactReferences';

interface TranscriptSummaryProps {
  summary: string | null;
  transcriptId: string;
  caseId: string;
  speakers?: Array<{ id: string; name: string }>;
  onSubfactClick?: (blockId: string) => void;
}

export const TranscriptSummary = ({
  summary,
  transcriptId,
  caseId,
  onSubfactClick,
}: TranscriptSummaryProps) => {
  if (!summary) {
    return (
      <div className="rounded bg-white p-6 text-center">
        <FileText className="mx-auto mb-4 h-12 w-12 text-gray-400" />
        <h3 className="mb-2 text-lg font-medium text-gray-900">No Summary Available</h3>
        <p className="mb-4 text-sm text-gray-500">A summary will be generated when the transcript is completed.</p>
      </div>
    );
  }

  return (
    <div className="rounded bg-white">
      <div className="px-6 py-8">
        <div className="markdown-content prose prose-sm max-w-none">
          <TextWithSubfactReferences
            text={summary}
            caseId={caseId}
            transcriptId={transcriptId}
            onBlockClick={onSubfactClick}
          />
        </div>
      </div>
    </div>
  );
};
